<template>
  <VDropdown
    v-model:shown="isMenuShown"
    :aria-id="ariaId"
    auto-size="min"
    :distance="16"
    placement="bottom-end"
  >
    <div
      :class="
        twJoin(
          'flex gap-x-2 cursor-pointer',
          $props.intent === 'button' && 'bg-gray-10 rounded-lg px-4 py-2'
        )
      "
    >
      <div
        v-if="!!$props.label"
        :class="
          twJoin(
            'text-primary-white',
            ['button', 'normal'].includes($props.intent || '') && '!text-black '
          )
        "
      >
        {{ $props.label }}
      </div>
      <div
        v-if="selectedOption"
        :class="
          twJoin(
            'text-primary-white font-bold',
            ['button', 'normal'].includes($props.intent || '') && '!text-black '
          )
        "
      >
        {{ $t(selectedOption?.label) }}
      </div>
      <div
        :class="
          twJoin(
            'text-primary-white transition-all ease-in-out',
            ['button', 'normal'].includes($props.intent || '') &&
              '!text-black ',
            isMenuShown && 'rotate-180'
          )
        "
      >
        <Icon name="chevron-down" />
      </div>
    </div>
    <template #popper>
      <div>
        <div
          v-for="(option, index) in options"
          :key="index"
          class="p-2 hover:bg-primary-tangerine hover:text-primary-white cursor-pointer rounded-md"
          @click="
            () => {
              emit('change', option.value)
              selected = option.value
              isMenuShown = false
            }
          "
        >
          {{ $t(option.label) }}
        </div>
      </div>
    </template>
  </VDropdown>
</template>

<script lang="ts" setup>
import { twJoin } from 'tailwind-merge'
import { filter, find } from 'lodash-es'

const emit = defineEmits<{
  (e: 'change', value: Option['value']): void
}>()

type Option<T = Record<string, unknown>> = {
  label: string
  // TODO: type this properly
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any
} & T

const props = defineProps<{
  intent?: 'button' | 'ghost' | 'normal'
  label?: string
  options?: Option[]
  default?: Option['value']
}>()

const ariaId = useId()
const isMenuShown = ref(false)
const selected = computed(() => props.default)
const selectedOption = computed(() =>
  find(props.options, { value: selected.value })
)
const options = computed(() =>
  filter(props.options, (item) => item.value !== selected.value)
)
</script>

<style>
.v-popper__arrow-container {
  display: none;
}

.v-popper__inner {
  padding: 8px;
  border-radius: 16px !important;
  overflow: hidden;
}

.v-popper__inner > div {
  overflow-y: scroll;
  max-height: 320px;
}

.v-popper__inner > div::-webkit-scrollbar {
  display: none;
}
</style>
